var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fileOpen2"},[(_vm.isRefreshView)?_c('input',{ref:"input",staticClass:"input",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.onFileChange}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }